import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { styled } from 'styled-components';
import themeHelper from '../../utils/themeHelper';
import Period from '../Period';
import Sport from '../Sport';

const MatchInfoContainer = styled.div`
  display: flex;
  justify-content: left;
  padding: ${themeHelper.spacing(0.25)};
`;

const SportIconContainer = styled.span`
  padding-right: ${themeHelper.spacing(0.25)};
`;

export function MatchInfo({ listing }) {
  const intl = useIntl();

  const unknown = intl.formatMessage({
    defaultMessage: 'Not Provided',
    id: '99817',
  });

  return (
    <MatchInfoContainer>
      <SportIconContainer>
        <Sport sport={listing.sport} hideText />
      </SportIconContainer>
      <span>
        <FormattedMessage
          defaultMessage="#{id} "
          id="a1b4f"
          values={{ id: listing.matchId || unknown }}
        />
        (
        <Period period={listing.matchPart} sport={listing.sport} />)
      </span>
    </MatchInfoContainer>
  );
}
MatchInfo.propTypes = {
  listing: PropTypes.shape({
    matchId: PropTypes.string,
    matchPart: PropTypes.string,
    sport: PropTypes.string,
  }).isRequired,
};

export default { MatchInfo };
